'use client';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import clamp from 'lodash/clamp';
import React from 'react';

import Odometer from '1_components/Odometer/Odometer';
import RevealAnimation from '1_components/RevealAnimation/RevealAnimation';

import LoadingCircle from './LoadingCircle/LoadingCircle';

import S from './Preloader.module.scss';

import useSmoothValueUpdate from 'hooks/useSmoothValueUpdate';
import { FADE_IN_OUT_ANIMATION } from 'styles/animations';
import { fonts } from 'styles/fontsRegistry';

export interface PreloaderProps {
  className?: string;
  progress: number;
  hideLoadingCircle?: boolean;
  hideBottomRow?: boolean;
  hideHeading?: boolean;

  onAnimationComplete: () => void;
  loadInterval?: number;
  delay?: number;
}

const Preloader: React.FC<PreloaderProps> = ({
  className,
  progress = 0,
  hideLoadingCircle,
  hideBottomRow,
  hideHeading,
  onAnimationComplete,
  loadInterval = 50,
  delay = 0,
}) => {
  const animatedProgress = useSmoothValueUpdate({
    initialValue: 0,
    targetValue: progress,
    interval: loadInterval,
    delay,
  });

  return (
    <motion.section
      className={clsx(S.PreloaderWrapper, className)}
      {...FADE_IN_OUT_ANIMATION}
    >
      {!hideHeading && (
        <div className={S.Heading}>
          <RevealAnimation>
            <p className={fonts.support}>Initialising interface</p>
          </RevealAnimation>
        </div>
      )}

      {!hideLoadingCircle && (
        <LoadingCircle
          progress={clamp(animatedProgress, 0, 100)}
          onAnimationComplete={() => {}}
          className={S.LoadingCircle}
        />
      )}
      {!hideBottomRow && (
        <div className={S.BottomRow}>
          <RevealAnimation>
            <span className={clsx(fonts.support, S.Loading)}>Loading...</span>
          </RevealAnimation>

          <Odometer
            value={clamp(animatedProgress, 0, 100)}
            onAnimationComplete={() => {
              onAnimationComplete();
            }}
          />
        </div>
      )}
    </motion.section>
  );
};

export default Preloader;
